import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './baseQueryWithReauth';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Farm',
    'FarmUsers',
    'Field',
    'Plot',
    'Bed',
    'Plan',
    'Crop',
    'CropAttribute',
    'CropPropertyBinding',
    'Planting',
    'PlantingAttribute',
    'PlantingEvent',
    'EventQueue',
    'EventTemplate',
    'HarvestRecord',
    'InventoryLot',
    'InventoryTransaction',
    'LiveAsset',
    'AdminUsers',
    'AdminPendingUsers',
    'Automation',
    'SaveV2',
    'Season',
    'SeasonAttempts',
    'Wallet',
    'ScenarioTemplate',
    'GardenPlan',
  ],
  endpoints: (builder) => ({
    requestPin: builder.mutation<{ message: string }, { pseudo?: string; tempToken?: string }>({
      query: (body) => ({ url: '/auth/request-pin', method: 'POST', body }),
    }),
    verifyPin: builder.mutation<{ accessToken: string; refreshToken: string }, { pseudo?: string; pin?: string; tempToken?: string }>({
      query: ({ pseudo, pin, tempToken }) => {
        if (tempToken) {
          return { url: `/auth/verify?token=${tempToken}`, method: 'GET' };
        }
        return { url: '/auth/verify-pin', method: 'POST', body: { pseudo, pin } };
      },
    }),
    getProducts: builder.query<any, void>({
      query: () => ({ url: '/products' }),
    }),
  }),
});

export const { useRequestPinMutation, useVerifyPinMutation, useGetProductsQuery } = apiSlice;
